<template>
  <div>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editTechLevel"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteTechLevel"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="orderUp">
      <i class="material-icons-outlined align-middle">arrow_upward</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="orderDown"
    >
      <i class="material-icons-outlined align-middle">arrow_downward</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editTechLevel: function () {
      this.params.context.componentParent.editTechLevel(this.params.data);
    },
    deleteTechLevel: function () {
      this.params.context.componentParent.deleteTechLevel(this.params.data);
    },
    orderUp: function () {
      this.params.context.componentParent.orderUpTechLevel(this.params.data);
    },
    orderDown: function () {
      this.params.context.componentParent.orderDownTechLevel(this.params.data);
    },
  },
};
</script>
